/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1AwardsQueryResponse } from '../../types/GetV1Awards.ts'

export const getV1AwardsQueryKey = () => [{ url: '/v1/Awards' }] as const

export type GetV1AwardsQueryKey = ReturnType<typeof getV1AwardsQueryKey>

/**
 * {@link /v1/Awards}
 */
export async function getV1Awards(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1AwardsQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/Awards`,
        ...requestConfig,
    })
    return res
}

export function getV1AwardsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1AwardsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1AwardsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1AwardsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Awards(config)
        },
    })
}

/**
 * {@link /v1/Awards}
 */
export function useGetV1Awards<
    TData = ResponseConfig<GetV1AwardsQueryResponse>,
    TQueryData = ResponseConfig<GetV1AwardsQueryResponse>,
    TQueryKey extends QueryKey = GetV1AwardsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1AwardsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1AwardsQueryKey()

    const query = useQuery(
        {
            ...getV1AwardsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
